﻿window["DealPage"] = {};

let windowWidth = window.innerWidth;

(function (DealPage) {

    // Initialize the ViewModel
    DealPage.init = function (capId, vehicleType, specificationDate, monthlyDealPrice, calculator,
        companyName, profileGuid, manufacturer, range, derivative, dealIdentifier, sessionReference, financeType) {

        viewModel = new DealPage.ViewModel(monthlyDealPrice, companyName, profileGuid, manufacturer, range, derivative, dealIdentifier, sessionReference,
            financeType, capId, vehicleType, specificationDate, calculator);

        ko.applyBindings(viewModel);
    };

    DealPage.enquiryCompleted = function () {
        viewModel.enquiryCompleted(true);
        $('html, body').animate({ scrollTop: 0 }, 500);
    };

    DealPage.enquirerHasVisitorAccount = function (hasAccount) {
        viewModel.enquirerHasVisitorAccount(hasAccount);
    };

    DealPage.scrollToEnquirySteps = function () {
        var scrollToDesktopElementName = "#EnquiryForm";
        $('html, body').animate({ scrollTop: $(scrollToDesktopElementName).offset().top - 10 }, 500);
    };

    DealPage.isCallbackEnquiry = function () {
        return viewModel.isCallbackEnquiry();
    };

    DealPage.formatStringToCurrency = function (string) {
        return "£" + string.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

})(DealPage || (DealPage = {}));

(() => {
    let flexslider1 = null;
    let flexslider2 = null;

    document.addEventListener("DOMContentLoaded", function () {
        initFlexslider();
        initDealPage();
    });

    const initDealPage = () => {
        const dealDetails = window["dealDetails"];

        if (dealDetails) {
            const calculator = new DealPage.DealCostCalculator(
                dealDetails.financeType,
                dealDetails.monthsUpfront,
                dealDetails.term,
                dealDetails.additionalFees
            );

            DealPage.init(
                dealDetails.capId, dealDetails.vehicleType, dealDetails.specificationDate,
                dealDetails.monthlyPrice, calculator, dealDetails.companyName, dealDetails.profileGuid,
                dealDetails.manufacturer, dealDetails.range, dealDetails.derivative, dealDetails.dealIdentifier,
                dealDetails.sessionReference, dealDetails.financeType
            );
        }
    };

    const initFlexslider = () => {
        if ($().flexslider) {
            $('#deal-thumbnails').flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: true,
                slideshow: false,
                itemMargin: 8,
                itemWidth: 115,
                minItems: 3,
                maxItems: 6,
                asNavFor: '#dealpage-carousel',
                start: (carousel) => {
                    carousel.resize();
                }
            });

            $('#dealpage-carousel').flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: true,
                slideshow: false,
                itemMargin: 0,
                sync: "#deal-thumbnails",
                start: (slider) => {
                    flexslider1 = slider;
                    $('#dealpage-carousel .total-slides').text(slider.count);
                    $('#dealpage-carousel .current-slide').text(slider.currentSlide + 1);
                    slider.resize();
                },
                after: function (slider) {
                    $('#dealpage-carousel .current-slide').text(slider.currentSlide + 1);
                }
            });

            if (flexslider1) {
                flexslider1.resize();
            }
        }
    };

    const initializeModalFlexslider = () => {
        if ($().flexslider) {
            $('#deal-thumbnails2').flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: true,
                slideshow: false,
                itemMargin: 8,
                itemWidth: 115,
                minItems: 3,
                maxItems: 8,
                asNavFor: '#dealpage-carousel2',
                start: (carousel2) => {
                    carousel2.resize();
                }
            });

            $('#dealpage-carousel2').flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: true,
                slideshow: false,
                itemMargin: 0,
                sync: "#deal-thumbnails2",
                start: (slider2) => {
                    flexslider2 = slider2;
                    $('#dealpage-carousel2 .total-slides').text(slider2.count);
                    $('#dealpage-carousel2 .current-slide').text(slider2.currentSlide + 1);
                    slider2.resize();
                },
                after: function (slider2) {
                    $('#dealpage-carousel2 .current-slide').text(slider2.currentSlide + 1);
                }
            });

            if (flexslider2) {
                flexslider2.resize();
            }

            $('#dealpage-carousel2 img, #deal-thumbnails2 img').css('height', 'auto');
        }
    };

    window.delayedInitModalFlexslider = () => {
        $('#dealpage-carousel2 img, #deal-thumbnails2 img').css('height', '0');
        setTimeout(() => {
            initializeModalFlexslider();
        }, 200);
    };

})();